import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { registerServiceWorker } from "@/registerServiceWorker";
import { isTenantPublicHost } from "@/config/tenantPublicSite";

// ResizeObserver loop completed limit hatalarını kökten çözmek için yerleşik sınıfı sarmalıyoruz.
// Bu yöntem callback'leri requestAnimationFrame içerisine alarak aynı frame içindeki aşırı tetiklenmeleri engeller.
const RO = window.ResizeObserver;
if (RO) {
  window.ResizeObserver = class ResizeObserver extends RO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Hataları sessizce yut
          }
        });
      });
    }
  };
}

const resizeObserverErrGuid = 'f6dc944c-f91f-42e4-988e-db4a20b2d00d';
const handler = e => {
  const msg = e.message || (e.reason && e.reason.message);
  if (msg && (msg.includes('ResizeObserver loop completed') || msg.includes('ResizeObserver loop limit exceeded'))) {
    if (window[resizeObserverErrGuid]) return;
    window[resizeObserverErrGuid] = true;
    setTimeout(() => { window[resizeObserverErrGuid] = false; }, 100);
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
  }
};
window.addEventListener('error', handler);
window.addEventListener('unhandledrejection', handler);

const root = ReactDOM.createRoot(document.getElementById("root"));
const hostname =
  typeof window !== "undefined" ? window.location.hostname : "";

const bootstrap = isTenantPublicHost(hostname)
  ? import("@/TenantPublicApp")
  : import("@/App");

bootstrap.then(({ default: RootApp }) => {
  // NOT: React.StrictMode geliştirme (dev) modunda tüm effect'leri ve fetch'leri
  // BİLEREK iki kez çalıştırır. İş emri gibi çok sayıda istek yapan ağır sayfalarda
  // bu, açılışta istek sayısını ikiye katlayıp sayfayı yavaşlatıyordu. Prod build'i
  // etkilemez; sadece dev deneyimini hızlandırmak için kaldırıldı.
  root.render(<RootApp />);
});

registerServiceWorker();
